import { render, staticRenderFns } from "./FormBlockContent.vue?vue&type=template&id=7044cbe8&"
import script from "./FormBlockContent.vue?vue&type=script&lang=js&"
export * from "./FormBlockContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports